import React from 'react';
import { arrowWidth, trackPropTypes, tracksWidth } from "../../../config/defaults";
import {
	getLabelColorByStateAndDifficulty,
	getTrackColorByStateAndDifficulty,
	renderLabelHelper
} from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE, TRACK_DIFFICULTY_RED } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const renderLabel = (coords, color, onLabelClick) => {
	return renderLabelHelper(coords, color, onLabelClick, '15E', 'Track15EBlue', "7.87695312")
};

const Track15EBlue = ({ state, workState, onLabelClick }) => (
	<g id="Track15EBlue" transform="translate(2094.000000, 923.000000)" className="track">
		<g stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)} strokeWidth={tracksWidth}
			 strokeLinecap="round">
			<path
				d="M201.230899,188.113209 C200.353171,183.851936 199.036578,177.460025 197.281122,168.937479 C191.975182,143.177718 176.734665,120.545275 154.86066,105.942324 L115.872899,79.9143352 C111.279579,76.8478628 105.07009,78.0856177 102.003618,82.678938 C101.361277,83.6411115 100.890766,84.7074489 100.613024,85.8304979 L86.4394994,143.141051 C85.3787682,147.43011 81.0419062,150.047187 76.7528468,148.986456 C75.0348607,148.56158 73.5062496,147.57903 72.4063105,146.192621 L38.7493999,103.770045 C31.1145354,94.1467433 20.7590025,87.0452373 9.03125,83.3902518 C2.25922582,81.2797323 -1.51967038,74.0790079 0.590849099,67.3069838 C1.06965639,65.7706348 1.83292276,64.3379508 2.84090934,63.0835236 L13.3843336,49.9623579 M20.6919765,40.8680837 L53.53125,0"/>

			<TrackArrow
				transform="translate(12.104417, 51.383706) rotate(130.000000) translate(-12.104417, -51.383706) "
				points="16.1044165 59.3837057 8.10441653 51.3837057 16.1044165 43.3837057"/>

			<path
				d="M203,281 L216.495602,254.008796 C219.920268,247.159463 219.578601,239.029705 215.591315,232.491872 L212.78765,227.894787 C210.395716,223.972803 208.555688,219.739892 207.319495,215.315513 L205.948954,210.410298 L205.948954,210.410298"
				id="line" stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
				strokeWidth={tracksWidth} strokeLinecap="round"/>

			<TrackArrow
				transform="translate(206.395575, 212.328073) rotate(-285.000000) translate(-206.395575, -212.328073) "
				points="210.395575 220.328073 202.395575 212.328073 210.395575 204.328073"
				strokeColor={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}/>
		</g>

		{renderLabel("176.000000, 142.207387", getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE), onLabelClick)}
		{renderLabel("74.031250, 104.000000", getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE), onLabelClick)}
		{renderLabel("4.031250, 73.000000", getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE), onLabelClick)}
	</g>
);

Track15EBlue.propTypes = trackPropTypes;
export default Track15EBlue;
